import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import LaddaButton, {ZOOM_OUT} from "react-ladda";
import { connect } from 'react-redux';
import {deleteShare} from "../../../reducer/shares/actions";
import PropTypes from "prop-types";

class ShareDeleteButton extends Component{
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      deleting: false
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.deleteShare = this.deleteShare.bind(this);
  }

  toggleModal() {
    this.setState({modal: !this.state.modal});
  }

  deleteShare() {
    this.setState({deleting: true});

    this.props.deleteShare({
      id: this.props.share.id
    }).then(() => this.setState({deleting: false, modal: false}))
      .catch(() => this.setState({deleting: false}));
  }

  render() {
    const modal = <Modal isOpen={this.state.modal} toggle={this.toggleModal}>
      <ModalHeader toggle={this.toggleModal} tag="h2"><FormattedMessage id="view.shareDeleteButton.modalHeader" /></ModalHeader>
      <hr className="m-0" />
      <ModalBody>
        <FormattedMessage id="view.shareDeleteButton.modalBody"/>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={this.toggleModal}><FormattedMessage id="_.button.cancel" /></Button>
          <LaddaButton
            className="btn btn-primary btn-ladda"
            loading={this.state.deleting}
            data-style={ZOOM_OUT}
            onClick={this.deleteShare}
          >
            <FormattedMessage id="_.button.delete" />
          </LaddaButton>
      </ModalFooter>
    </Modal>;

    return (
      <React.Fragment>
        <Button color="" className="m-0 p-0" onClick={this.toggleModal}><i className="fas fa-times"/></Button>
        {modal}
      </React.Fragment>
    )
  }
}

ShareDeleteButton.propTypes = {
  share: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired
};


export default connect(null, {deleteShare})(ShareDeleteButton);
